"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierCustom = void 0;
var modifierCustom = function (value, customFunction) {
    try {
        return customFunction(value);
    }
    catch (error) {
        console.log("Error running custom modifier");
    }
};
exports.modifierCustom = modifierCustom;
//# sourceMappingURL=modifierCustom.js.map